import * as React from 'react';
import './eyecatch.module.scss';
import { expandImageParams } from '../../../../../commonv2/utils/image';
import { EventCoachIndexView, EventShowView } from '../../../../types/events';
import { SimpleDate } from '../../../../../admin/components/date/TimeRange';
import { EventDetails } from '../../../../../mainv2/types/event';

type CoachProps = {
  coach: EventCoachIndexView;
  extraCoaches: number;
};

const CoachSummary = ({ coach, extraCoaches }: CoachProps) => {
  return (
    <div styleName="tutor-info">
      <img src={coach.profile_photo_url} styleName="tutor-profile-image" />
      <div>
        <div styleName="tutor-tutor-name">
          {coach.name} {extraCoaches > 0 && <span>他{extraCoaches}名</span>}
        </div>
        <div styleName="tutor-tutor-title">{coach.title}</div>
      </div>
    </div>
  );
};

type Props = {
  event: EventShowView | EventDetails;
};

export class EyeCatch extends React.Component<Props> {
  render() {
    const { event } = this.props;
    return (
      <div styleName="container">
        <div styleName="image-wrapper">
          <img {...expandImageParams(event.cover_photo_url)} styleName="image" />
        </div>
        <div styleName="image-overlay" />
        <div styleName="main">
          <div styleName="main-inner">
            <div styleName="date">
              <SimpleDate date={event.starts_at} />
            </div>
            <div styleName="title">{event.title}</div>
            <div styleName="subtitle">{event.sub_title}</div>
            <div styleName="tutors">
              {event.coaches.slice(0, 1).map((coach) => {
                return <CoachSummary key={coach.id} coach={coach} extraCoaches={event.coaches.length - 1} />;
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
